(function () {
  var MQ_MOBILE = window.matchMedia('(max-width: 768px)');
  var states = [];
  var ANIMATION_MS = 230;

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getDirectSlides(slider, includeClones) {
    var out = [];
    var children = slider ? slider.children : [];
    for (var i = 0; i < children.length; i++) {
      if (!children[i].classList || !children[i].classList.contains('product-main-slide')) continue;
      if (!includeClones && children[i].classList.contains('amz-scroll-clone')) continue;
      out.push(children[i]);
    }
    return out;
  }

  function getThumbs(root) {
    return qsa(root, '[data-product-thumb], [data-amz-mobile-product-thumb]');
  }

  function isMobileThumbLayout(root) {
    return root && root.getAttribute('data-amz-mobile-media-layout') === 'thumbnails';
  }

  function keepMobileThumbVisible(state, index) {
    if (!state || !isMobileThumbLayout(state.productImagesRoot)) return;
    var scroller = state.productImagesRoot.querySelector('[data-amz-mobile-product-thumbs] .amz-mobile-product-thumbs__scroller');
    if (!scroller) return;
    var active = scroller.querySelector('[data-amz-mobile-product-thumb][data-index="' + index + '"], [data-product-thumb][data-index="' + index + '"]');
    if (!active) return;
    var item = active.closest('.amz-mobile-product-thumbs__item') || active;
    var left = item.offsetLeft;
    var right = left + item.offsetWidth;
    var viewLeft = scroller.scrollLeft;
    var viewRight = viewLeft + scroller.clientWidth;
    var targetLeft = null;
    if (left < viewLeft) targetLeft = left;
    else if (right > viewRight) targetLeft = right - scroller.clientWidth;
    if (targetLeft === null) return;
    var previousScrollBehavior = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    if (typeof scroller.scrollTo === 'function') scroller.scrollTo({ left: targetLeft, behavior: 'auto' });
    else scroller.scrollLeft = targetLeft;
    window.setTimeout(function () { scroller.style.scrollBehavior = previousScrollBehavior; }, 80);
  }

  function getIndexFromEl(el) {
    var raw = el.getAttribute('data-amz-clone-of') || el.getAttribute('data-index') || el.dataset.index || '0';
    var index = parseInt(raw, 10);
    return isNaN(index) ? 0 : index;
  }

  function normalizeIndex(index, total) {
    if (!total) return 0;
    return ((index % total) + total) % total;
  }

  function getActiveThumbIndex(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) return getIndexFromEl(thumbs[i]);
    }
    return 0;
  }

  function buildDots(slider, count) {
    var existing = slider.parentNode ? slider.parentNode.querySelector('.amz-scroll-dots') : null;
    if (existing) existing.parentNode.removeChild(existing);
    var dots = document.createElement('div');
    dots.className = 'amz-scroll-dots';
    var btns = [];
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'amz-scroll-dot';
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dots.appendChild(b);
      btns.push(b);
    }
    slider.insertAdjacentElement('afterend', dots);
    return { el: dots, btns: btns };
  }

  function cleanClone(clone, cloneOf) {
    clone.classList.add('amz-scroll-clone');
    clone.setAttribute('data-amz-clone-of', String(cloneOf));
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('id');
    qsa(clone, '[id]').forEach(function (el) { el.removeAttribute('id'); });
    qsa(clone, 'a, button, input, select, textarea, iframe, video, model-viewer').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    try { clone.inert = true; } catch (e) {}
  }

  function removeLoopClones(state) {
    qsa(state.slider, ':scope > .amz-scroll-clone').forEach(function (clone) {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    });
    state.beforeClone = null;
    state.afterClone = null;
    state.loopEnabled = false;
    state.slides = getDirectSlides(state.slider, false);
    state.visualSlides = state.slides.slice(0);
  }

  function updateVisualSlides(state) {
    state.visualSlides = getDirectSlides(state.slider, true);
  }

  function setupLoopClones(state) {
    removeLoopClones(state);
    if (!MQ_MOBILE.matches || state.slides.length < 2) return;
    var first = state.slides[0].cloneNode(true);
    var lastIndex = state.slides.length - 1;
    var last = state.slides[lastIndex].cloneNode(true);
    cleanClone(first, 0);
    cleanClone(last, lastIndex);
    state.slider.insertBefore(last, state.slides[0]);
    state.slider.appendChild(first);
    state.beforeClone = last;
    state.afterClone = first;
    state.loopEnabled = true;
    updateVisualSlides(state);
  }

  function setX(state, x) {
    state.x = x;
    state.slider.style.setProperty('--amz-gallery-x', x + 'px');
  }

  function useNativeMobileMode(state) {
    return !!(state && MQ_MOBILE.matches && isMobileThumbLayout(state.productImagesRoot));
  }

  function nativeLeftForSlide(state, slide) {
    if (!state || !slide) return 0;
    return Math.max(0, Math.round(slide.offsetLeft || 0));
  }

  function moveNativeToSlide(state, slide, animate) {
    if (!state || !slide) return;
    var left = nativeLeftForSlide(state, slide);
    state.x = 0;
    state.slider.style.setProperty('--amz-gallery-x', '0px');
    var previousScrollBehavior = state.slider.style.scrollBehavior;
    if (!animate) {
      window.clearTimeout(state.nativeNoAnimTimer);
      state.slider.classList.add('amz-scroll-noanim');
      state.slider.style.scrollBehavior = 'auto';
    }
    if (typeof state.slider.scrollTo === 'function') {
      state.slider.scrollTo({ left: left, behavior: animate ? 'smooth' : 'auto' });
    } else {
      state.slider.scrollLeft = left;
    }
    if (!animate) {
      state.nativeNoAnimTimer = window.setTimeout(function () {
        state.slider.style.scrollBehavior = previousScrollBehavior;
        state.slider.classList.remove('amz-scroll-noanim');
      }, 80);
    }
  }

  function targetXForSlide(state, slide) {
    if (!state || !slide) return 0;
    var viewportCenter = (state.slider.clientWidth || 0) / 2;
    var slideCenter = (slide.offsetLeft || 0) + (slide.offsetWidth || 0) / 2;
    return Math.round(viewportCenter - slideCenter);
  }

  function setXNoAnimation(state, x) {
    window.clearTimeout(state.animTimer);
    state.slider.classList.add('amz-scroll-noanim');
    setX(state, x);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        state.slider.classList.remove('amz-scroll-noanim');
      });
    });
  }

  function moveToSlide(state, slide, animate, done) {
    if (!state || !slide) return;
    var x = targetXForSlide(state, slide);
    window.clearTimeout(state.animTimer);
    if (!animate) {
      setXNoAnimation(state, x);
      if (typeof done === 'function') window.requestAnimationFrame(done);
      return;
    }
    state.slider.classList.remove('amz-scroll-dragging');
    state.slider.classList.remove('amz-scroll-noanim');
    window.requestAnimationFrame(function () {
      setX(state, x);
      state.animTimer = window.setTimeout(function () {
        if (typeof done === 'function') done();
      }, ANIMATION_MS + 25);
    });
  }

  function visualSlideFor(state, index, direction, from) {
    var total = state.slides.length;
    var target = normalizeIndex(index, total);
    var start = typeof from === 'number' ? normalizeIndex(from, total) : normalizeIndex(state.index, total);
    if (state.loopEnabled && direction === 'prev' && start === 0 && target === total - 1 && state.beforeClone) return state.beforeClone;
    if (state.loopEnabled && direction === 'next' && start === total - 1 && target === 0 && state.afterClone) return state.afterClone;
    return state.slides[target];
  }

  function setActive(state, index) {
    if (!state || !state.slides.length) return;
    var total = state.slides.length;
    index = normalizeIndex(index, total);
    state.index = index;
    state.slides.forEach(function (slide, i) {
      slide.classList.toggle('is-selected', i === index);
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
    if (state.beforeClone) state.beforeClone.classList.toggle('is-selected', index === total - 1);
    if (state.afterClone) state.afterClone.classList.toggle('is-selected', index === 0);
    state.thumbs.forEach(function (thumb) {
      var isActive = getIndexFromEl(thumb) === index;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (!isActive && document.activeElement === thumb) thumb.blur();
    });
    if (state.dots && state.dots.btns) {
      state.dots.btns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
    keepMobileThumbVisible(state, index);
  }

  function goToIndex(state, index, animate, direction, from) {
    if (!state || !state.slides.length) return;
    var total = state.slides.length;
    var target = normalizeIndex(index, total);
    if (useNativeMobileMode(state)) {
      removeLoopClones(state);
      setActive(state, target);
      moveNativeToSlide(state, state.slides[target], animate);
      return;
    }
    var slide = visualSlideFor(state, target, direction, from);
    setActive(state, target);
    moveToSlide(state, slide, animate, function () {
      if (slide && slide.classList && slide.classList.contains('amz-scroll-clone')) {
        moveToSlide(state, state.slides[target], false);
      }
    });
  }

  function computeSlideCenters(state) {
    var slides = state.visualSlides && state.visualSlides.length ? state.visualSlides : state.slides;
    var out = [];
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      out.push({ center: (s.offsetLeft || 0) + (s.offsetWidth || 0) / 2, index: getIndexFromEl(s) });
    }
    return out;
  }

  function nearestIndex(state, cachedCenters) {
    var centers = cachedCenters || computeSlideCenters(state);
    var center = useNativeMobileMode(state)
      ? (state.slider.scrollLeft || 0) + ((state.slider.clientWidth || 0) / 2)
      : ((state.slider.clientWidth || 0) / 2) - (state.x || 0);
    var best = 0;
    var diff = Infinity;
    for (var i = 0; i < centers.length; i++) {
      var d = Math.abs(centers[i].center - center);
      if (d < diff) {
        diff = d;
        best = centers[i].index;
      }
    }
    return normalizeIndex(best, state.slides.length);
  }

  function parseVariants(productSection) {
    var jsonEl = productSection.querySelector('[data-variant-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || jsonEl.innerHTML || '[]');
    } catch (e) {
      return null;
    }
  }

  function findVariantById(variants, id) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }
function slugifyOptionValue(v) {
    return (v || '').toString().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function detectImageSet(productSection, slider) {
    var sample = slider.querySelector('.product-main-slide[data-set-name]');
    if (!sample) return null;
    var setName = (sample.getAttribute('data-set-name') || '').trim();
    if (!setName) return null;

    var wrap = productSection.querySelector('.variant-input-wrap[data-handle="' + setName + '"]');

    if (!wrap) {
      var wraps = qsa(productSection, '.variant-input-wrap[data-index]');
      var seenHandles = {};
      var distinctWraps = [];
      wraps.forEach(function (w) {
        var handle = w.getAttribute('data-handle') || '';
        if (seenHandles[handle]) return;
        seenHandles[handle] = true;
        distinctWraps.push(w);
      });
      if (distinctWraps.length === 1) wrap = distinctWraps[0];
    }

    if (!wrap) return null;
    var optionKey = wrap.getAttribute('data-index');
    if (!optionKey) return null;
    return { name: setName, optionKey: optionKey };
  }

  function groupValueForVariant(imageSet, variant) {
    if (!imageSet || !variant) return null;
    var raw = variant[imageSet.optionKey];
    if (!raw) return null;
    return imageSet.name + '_' + slugifyOptionValue(raw);
  }

  function normalizeGroupValue(g) {
    return g ? g.toString().trim().toLowerCase() : g;
  }

  function groupOf(el) {
    var g = el.getAttribute('data-group');
    if (!g) {
      var wrap = closest(el, '.product__thumb-item') || closest(el, '.amz-mobile-product-thumbs__item');
      g = wrap ? wrap.getAttribute('data-group') : null;
    }
    return normalizeGroupValue(g);
  }

  function matchesGroup(el, groupValue) {
    var g = groupOf(el);
    return !g || g === normalizeGroupValue(groupValue);
  }

  function applyImageSet(state, groupValue) {
    if (!state.imageSet || !groupValue) return;
    if (state.currentGroupValue === groupValue) return;
    state.currentGroupValue = groupValue;

    state.allSlides.forEach(function (slide) {
      slide.style.display = matchesGroup(slide, groupValue) ? 'block' : 'none';
    });
    state.allThumbs.forEach(function (thumb) {
      var show = matchesGroup(thumb, groupValue);
      var wrap = closest(thumb, '.product__thumb-item') || thumb;
      wrap.style.display = show ? '' : 'none';
    });

    state.slides = state.allSlides.filter(function (s) { return matchesGroup(s, groupValue); });
    state.thumbs = state.allThumbs.filter(function (t) { return matchesGroup(t, groupValue); });

    if (!isMobileThumbLayout(state.productImagesRoot)) {
      state.dots = buildDots(state.slider, state.slides.length);
      bindDots(state);
    }

    state.index = 0;
    syncLayout(state);
  }

  function reorderChildrenByGroup(container, items, groupValue) {
    if (!container || !items || items.length < 2) return items || [];
    var priority = [];
    var rest = [];
    items.forEach(function (it) {
      if (normalizeGroupValue(it.getAttribute('data-group')) === groupValue) priority.push(it);
      else rest.push(it);
    });
    if (!priority.length || !rest.length) return items;
    var ordered = priority.concat(rest);
    ordered.forEach(function (el) { container.appendChild(el); });
    return ordered;
  }

  function reorderByGroup(state, groupValue) {
    if (!state.imageSet || !groupValue) return;
    groupValue = normalizeGroupValue(groupValue);
    if (state.currentGroupValue === groupValue) return;
    state.currentGroupValue = groupValue;

    removeLoopClones(state);

    var orderedSlides = reorderChildrenByGroup(state.slider, state.slides, groupValue);
    orderedSlides.forEach(function (slide, i) { slide.setAttribute('data-index', String(i)); });
    state.slides = orderedSlides;
    state.allSlides = orderedSlides;

    var deskScroller = state.productImagesRoot.querySelector('[data-product-thumbs] .product__thumbs--scroller');
    if (deskScroller) {
      var deskItems = qsa(deskScroller, ':scope > .product__thumb-item');
      var orderedDesk = reorderChildrenByGroup(deskScroller, deskItems, groupValue);
      orderedDesk.forEach(function (item, i) {
        item.setAttribute('data-index', String(i));
        var a = item.querySelector('[data-product-thumb]');
        if (a) a.setAttribute('data-index', String(i));
      });
    }

    var mobScroller = state.productImagesRoot.querySelector('[data-amz-mobile-product-thumbs] .amz-mobile-product-thumbs__scroller');
    if (mobScroller) {
      var mobItems = qsa(mobScroller, ':scope > .amz-mobile-product-thumbs__item');
      var orderedMob = reorderChildrenByGroup(mobScroller, mobItems, groupValue);
      orderedMob.forEach(function (item, i) {
        item.setAttribute('data-index', String(i));
        var a = item.querySelector('[data-amz-mobile-product-thumb]');
        if (a) a.setAttribute('data-index', String(i));
      });
    }

    state.thumbs = getThumbs(state.productImagesRoot);
    state.allThumbs = state.thumbs;
    bindThumbs(state);

    if (!isMobileThumbLayout(state.productImagesRoot)) {
      state.dots = buildDots(state.slider, state.slides.length);
      bindDots(state);
    }

    state.index = 0;
    syncLayout(state);
  }
  function getVariantIdFromDOM(productSection) {
    var idInput = productSection.querySelector('input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    var select = productSection.querySelector('[data-product-select]');
    if (select && select.value) return select.value;
    var checked = productSection.querySelector('[data-variant-input]:checked');
    if (checked && checked.value) return checked.value;
    return null;
  }

  function ensureInstantNativeIndex(state, index) {
    if (!state || !useNativeMobileMode(state)) return;
    window.clearTimeout(state.variantJumpTimerOne);
    window.clearTimeout(state.variantJumpTimerTwo);
    window.clearTimeout(state.variantJumpTimerThree);
    function apply() {
      if (!useNativeMobileMode(state)) return;
      goToIndex(state, index, false);
    }
    apply();
    window.requestAnimationFrame(apply);
    state.variantJumpTimerOne = window.setTimeout(apply, 30);
    state.variantJumpTimerTwo = window.setTimeout(apply, 90);
    state.variantJumpTimerThree = window.setTimeout(apply, 180);
  }

  function goToVariantIndex(state, index) {
    if (useNativeMobileMode(state)) {
      ensureInstantNativeIndex(state, index);
      return;
    }
    goToIndex(state, index, true);
  }

  function gotoVariantImage(state, variant) {
    if (!state || !variant) return;
    var mediaId = variant.featured_media && variant.featured_media.id;
    if (mediaId) {
      for (var i = 0; i < state.thumbs.length; i++) {
        var id = state.thumbs[i].getAttribute('data-id') || '';
        if (String(id) === String(mediaId)) {
          goToVariantIndex(state, getIndexFromEl(state.thumbs[i]));
          return;
        }
      }
    }
    var imageId = variant.featured_image && variant.featured_image.id;
    if (imageId) {
      for (var j = 0; j < state.thumbs.length; j++) {
        var tid = state.thumbs[j].getAttribute('data-id') || '';
        if (String(tid) === String(imageId)) {
          goToVariantIndex(state, getIndexFromEl(state.thumbs[j]));
          return;
        }
      }
    }
    var pos = variant.featured_image && variant.featured_image.position;
    if (pos && !isNaN(pos)) {
      var idxPos = parseInt(pos, 10) - 1;
      if (idxPos >= 0 && idxPos < state.slides.length) {
        goToVariantIndex(state, idxPos);
        return;
      }
    }
    var imgSrc = variant.featured_image && (variant.featured_image.src || variant.featured_image);
    if (imgSrc) {
      for (var s = 0; s < state.slides.length; s++) {
        var img = state.slides[s].querySelector('img');
        if (img && img.getAttribute('src') && img.getAttribute('src').indexOf(imgSrc.split('?')[0]) >= 0) {
          goToVariantIndex(state, s);
          return;
        }
      }
    }
  }

  function bindTouch(state) {
    if (state.touchBound || useNativeMobileMode(state)) return;
    state.touchBound = true;

    state.slider.addEventListener('touchstart', function (e) {
      if (!MQ_MOBILE.matches || !e.touches || !e.touches.length) return;
      var t = e.touches[0];
      window.clearTimeout(state.animTimer);
      state.slider.classList.add('amz-scroll-dragging');
      state.touchActive = true;
      state.touch = {
        startX: t.clientX,
        startY: t.clientY,
        lastX: t.clientX,
        startXValue: state.x || 0,
        startIndex: state.index || 0,
        horizontal: false,
        vertical: false,
        slideCenters: computeSlideCenters(state)
      };
    }, { passive: true });

    state.slider.addEventListener('touchmove', function (e) {
      if (!state.touchActive || !state.touch || !e.touches || !e.touches.length) return;
      var t = e.touches[0];
      var dx = t.clientX - state.touch.startX;
      var dy = t.clientY - state.touch.startY;
      state.touch.lastX = t.clientX;
      if (!state.touch.horizontal && !state.touch.vertical) {
        var absDx = Math.abs(dx);
        var absDy = Math.abs(dy);
        if (absDx > 12 || absDy > 12) {
          if (absDx > absDy * 1.7) state.touch.horizontal = true;
          else state.touch.vertical = true;
        }
      }
      if (!state.touch.horizontal) return;
      if (e.cancelable) e.preventDefault();
      setX(state, state.touch.startXValue + dx);
      setActive(state, nearestIndex(state, state.touch.slideCenters));
    }, { passive: false });

    function finishTouch(e) {
      if (!state.touchActive || !state.touch) return;
      var touch = state.touch;
      state.touchActive = false;
      state.touch = null;
      if (!touch.horizontal) {
        state.slider.classList.remove('amz-scroll-dragging');
        goToIndex(state, state.index || 0, true);
        return;
      }
      if (e && e.cancelable) e.preventDefault();
      var dx = touch.lastX - touch.startX;
      var threshold = Math.max(24, Math.min(56, (state.slider.clientWidth || 0) * 0.075));
      var target = touch.startIndex;
      var direction = '';
      if (Math.abs(dx) >= threshold) {
        if (dx < 0) {
          target = touch.startIndex + 1;
          direction = 'next';
        } else {
          target = touch.startIndex - 1;
          direction = 'prev';
        }
      }
      state.slider.classList.remove('amz-scroll-dragging');
      goToIndex(state, target, true, direction, touch.startIndex);
    }

    state.slider.addEventListener('touchend', finishTouch, { passive: false });
    state.slider.addEventListener('touchcancel', finishTouch, { passive: false });
  }

  function bindNativeScroll(state) {
    if (state.nativeScrollBound) return;
    state.nativeScrollBound = true;
    var raf = null;
    var endTimer = null;
    function update() {
      raf = null;
      if (!useNativeMobileMode(state)) return;
      state.nativeScrolling = true;
      setActive(state, nearestIndex(state));
      window.clearTimeout(endTimer);
      endTimer = window.setTimeout(function () {
        state.nativeScrolling = false;
        setActive(state, nearestIndex(state));
      }, 80);
    }
    state.slider.addEventListener('scroll', function () {
      if (!useNativeMobileMode(state)) return;
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    }, { passive: true });
    state.slider.addEventListener('touchmove', function () {
      if (!useNativeMobileMode(state) || raf) return;
      raf = window.requestAnimationFrame(update);
    }, { passive: true });
  }

  function selectVariantForThumb(state, thumb) {
    if (!state.imageSet) return;
    var group = groupOf(thumb);
    if (!group) return;
    var prefix = normalizeGroupValue(state.imageSet.name + '_');
    if (group.indexOf(prefix) !== 0) return;
    var targetSlug = group.slice(prefix.length);
    if (!targetSlug) return;

    var wrap = state.productSection.querySelector(
      '.variant-input-wrap[data-handle="' + state.imageSet.name + '"][data-index="' + state.imageSet.optionKey + '"]'
    ) || state.productSection.querySelector('.variant-input-wrap[data-index="' + state.imageSet.optionKey + '"]');
    if (!wrap) return;

    var inputs = qsa(wrap, '[data-variant-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (slugifyOptionValue(inputs[i].value) === targetSlug) {
        if (!inputs[i].checked) {
          state.suppressReorder = true;
          inputs[i].click();
        }
        return;
      }
    }

    var select = wrap.querySelector('select');
    if (select) {
      for (var j = 0; j < select.options.length; j++) {
        if (slugifyOptionValue(select.options[j].value) === targetSlug) {
          if (select.value !== select.options[j].value) {
            state.suppressReorder = true;
            select.value = select.options[j].value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
    }
  }

  function bindThumbs(state) {
    state.thumbs.forEach(function (thumb) {
      if (thumb.__amzScrollBound) return;
      thumb.__amzScrollBound = true;
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        selectVariantForThumb(state, thumb);
        var index = getIndexFromEl(thumb);
        if (useNativeMobileMode(state)) {
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          state.nativeScrolling = false;
          goToIndex(state, index, false);
          return;
        }
        goToIndex(state, index, true);
      });
    });
  }

  function bindDots(state) {
    if (!state.dots || !state.dots.btns) return;
    state.dots.btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        if (state.thumbs[i]) selectVariantForThumb(state, state.thumbs[i]);
        goToIndex(state, i, true);
      });
    });
  }

  function syncLayout(state) {
    if (!state || !state.slider) return;
    if (useNativeMobileMode(state)) {
      removeLoopClones(state);
      setActive(state, state.index || 0);
      moveNativeToSlide(state, state.slides[state.index || 0], false);
      window.setTimeout(function () { moveNativeToSlide(state, state.slides[state.index || 0], false); }, 120);
      window.setTimeout(function () { moveNativeToSlide(state, state.slides[state.index || 0], false); }, 450);
      return;
    }
    setupLoopClones(state);
    setActive(state, state.index || 0);
    moveToSlide(state, state.slides[state.index || 0], false);
    window.setTimeout(function () { moveToSlide(state, state.slides[state.index || 0], false); }, 120);
    window.setTimeout(function () { moveToSlide(state, state.slides[state.index || 0], false); }, 450);
  }

function initOne(productSection) {
    var productImagesRoot = productSection.querySelector('[data-product-images]');
    if (!productImagesRoot) return;
    var slider = productImagesRoot.querySelector('[data-product-photos].product-slideshow');
    if (!slider) return;
    if (slider.dataset.amzScrollReady === '1' && slider.__amzScrollState) return;

    qsa(slider, ':scope > .amz-scroll-clone').forEach(function (clone) {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    });

    var slides = getDirectSlides(slider, false);
    if (slides.length <= 1) return;

    slider.dataset.amzScrollReady = '1';
    slider.classList.add('amz-scroll-slider');
    slider.scrollLeft = 0;

    slides.forEach(function (slide, i) {
      if (!slide.hasAttribute('data-index')) slide.setAttribute('data-index', String(i));
      slide.style.display = 'block';
    });

    var thumbs = getThumbs(productImagesRoot);
    var dots = isMobileThumbLayout(productImagesRoot) ? null : buildDots(slider, slides.length);
    var state = {
      productSection: productSection,
      productImagesRoot: productImagesRoot,
      slider: slider,
      slides: slides,
      allSlides: slides,
      visualSlides: slides.slice(0),
      thumbs: thumbs,
      allThumbs: thumbs,
      dots: dots,
      index: normalizeIndex(getActiveThumbIndex(thumbs), slides.length),
      partial: !!closest(slider, '.grid--product-images--partial'),
      loopEnabled: false,
      beforeClone: null,
      afterClone: null,
      x: 0,
      touchActive: false,
      touch: null,
      nativeScrolling: false,
      imageSet: detectImageSet(productSection, slider),
      currentGroupValue: null,
      suppressReorder: false
    };

    slider.__amzScrollState = state;
    states.push(state);
    syncLayout(state);
    bindThumbs(state);
    bindDots(state);
    bindNativeScroll(state);
    bindTouch(state);

    var variants = parseVariants(productSection);

      function applyVariant(v) {
      if (v) {
        var groupValue = groupValueForVariant(state.imageSet, v);
        if (state.suppressReorder) {
          state.suppressReorder = false;
          if (groupValue) state.currentGroupValue = normalizeGroupValue(groupValue);
        } else {
          reorderByGroup(state, groupValue);
        }
      }
      gotoVariantImage(state, v);
    }
    productSection.addEventListener('variantChange', function (evt) {
      var v = evt && evt.detail && evt.detail.variant;
      if (!v) {
        var id = getVariantIdFromDOM(productSection);
        v = findVariantById(variants, id);
      }
      applyVariant(v);
    });

    document.addEventListener('variant:change', function (evt) {
      if (!evt || !evt.detail) return;
      if (evt.detail.sectionId) {
        var thisId = productSection.getAttribute('data-section-id') || productSection.dataset.sectionId;
        if (thisId && String(evt.detail.sectionId) !== String(thisId)) return;
      }
      if (evt.detail.variant) {
        applyVariant(evt.detail.variant);
        return;
      }
      var id = getVariantIdFromDOM(productSection);
      var v = findVariantById(variants, id);
      applyVariant(v);
    });

    var variantSelect = productSection.querySelector('[data-product-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        setTimeout(function () {
          var id = getVariantIdFromDOM(productSection) || variantSelect.value;
          var v = findVariantById(variants, id);
          applyVariant(v);
        }, 0);
      });
    }

    qsa(productSection, '[data-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        setTimeout(function () {
          var id = getVariantIdFromDOM(productSection);
          var v = findVariantById(variants, id);
          applyVariant(v);
        }, 0);
      });
    });
  }

  function initAll(root) {
    qsa(root || document, '[data-apx-section="product"]').forEach(initOne);
  }

  function refreshAll() {
    states.forEach(syncLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  if (MQ_MOBILE.addEventListener) MQ_MOBILE.addEventListener('change', refreshAll);
  else if (MQ_MOBILE.addListener) MQ_MOBILE.addListener(refreshAll);

  window.addEventListener('resize', function () {
    window.clearTimeout(window.__amzProductGalleryResizeTimer);
    window.__amzProductGalleryResizeTimer = window.setTimeout(refreshAll, 160);
  });

  window.addEventListener('load', function () {
    window.setTimeout(refreshAll, 80);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();